module.exports = __webpack_public_path__ + "h5/img/live-logo.fe006f13.gif";